import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

export const EmailAlert = () => {
  const [health, setHealth] = useState(null);

  useEffect(() => {
    const load = () => api.get("/admin/email-health").then(({ data }) => setHealth(data)).catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, []);

  if (!health?.alert) return null;

  return (
    <div
      data-testid="email-failure-alert"
      className="flex flex-wrap items-center gap-3 border-b border-red-200 bg-red-50 px-5 py-3 text-sm text-red-800 sm:px-8"
    >
      <AlertTriangle className="h-4 w-4 shrink-0" />
      <span>
        <strong data-testid="email-failure-count">{health.consecutive_failures} emails</strong> ont échoué d'affilée
        {health.last_failure_at ? ` (dernier : ${new Date(health.last_failure_at).toLocaleString("fr-FR")})` : ""}.
        Les élèves et auto-écoles ne reçoivent plus rien.
      </span>
      <span className="hidden md:inline max-w-md truncate text-xs text-red-600" title={health.last_error}>
        {health.last_error}
      </span>
      <Link
        to="/admin/emails"
        data-testid="email-alert-link"
        className="ml-auto rounded-md bg-red-600 px-3 py-1.5 text-xs font-bold text-white transition-colors hover:bg-red-700"
      >
        Voir le journal
      </Link>
    </div>
  );
};
